// 每日大赛网 - 站内内容数据（单页吃瓜杂志站）

export const hotList = [
  { rank: 1, title: "《星光主理人》主题曲直拍播放量24小时破8000万", tag: "直拍热度", mark: "爆" },
  { rank: 2, title: "票池结算异常？网友晒出本轮打榜金额明细求解释", tag: "打榜争议", mark: "热" },
  { rank: 3, title: "导师林川被扒八年前旧帖：\"毒舌\"人设是剧本吗", tag: "导师考古", mark: "热" },
  { rank: 4, title: "35强淘汰名单提前泄露，节目组凌晨发声明", tag: "淘汰内幕", mark: "新" },
  { rank: 5, title: "陈希空降舞台秀高音，饭拍对比录音室版本", tag: "舞台对比", mark: "新" },
  { rank: 6, title: "某选手赛前点赞量暴涨疑买量，后援会回应", tag: "数据风波", mark: "新" },
];

export const pollGuides = [
  {
    id: "vote-1",
    title: "打榜基础课：一人一票的规则漏洞与正确姿势",
    lead: "从账号权重、签到加成到助力次数上限，把每日投满又不踩违规线的完整路径一次讲清。",
    tag: "打榜攻略",
    time: "6分钟阅读",
    img: "https://readdy.ai/api/search-image?query=Close%20view%20of%20a%20hand%20holding%20a%20phone%20glowing%20with%20an%20on-screen%20voting%20app%2C%20colorful%20voter%20lightsticks%20blurred%20in%20the%20background%2C%20editorial%20entertainment%20magazine%20photography%2C%20warm%20orange%20and%20crimson%20stage%20lighting%2C%20subtle%20film%20grain%2C%20rich%20contrast%2C%20central%20composition&width=800&height=560&seq=pol-guide-01&orientation=landscape",
  },
  {
    id: "vote-2",
    title: "黄金时段法则：何时投票的增量最明显？",
    lead: "复盘近十期榜单曲线后发现，某个固定时段投出的票在公开榜上加权更明显，附时间轴证据。",
    tag: "数据复盘",
    time: "8分钟阅读",
    img: "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20desk%20covered%20with%20charts%2C%20printed%20voting%20statistics%20and%20a%20laptop%20showing%20a%20rising%20line%20graph%2C%20editorial%20data%20journalism%20photography%2C%20warm%20desk%20lamp%20glow%2C%20cream%20paper%20tone%2C%20subtle%20film%20grain%2C%20top%20down%20central%20composition&width=800&height=560&seq=pol-guide-02&orientation=landscape",
  },
  {
    id: "vote-3",
    title: "双平台联动：App端与小程序端票数如何打通",
    lead: "同一账号在两端的助力是否叠加、切号风险在哪，实测十组账号后给你结论与避坑清单。",
    tag: "打榜攻略",
    time: "7分钟阅读",
    img: "https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20showing%20a%20fan%20voting%20app%20and%20a%20mini%20program%2C%20warm%20backstage%20bokeh%20lights%20behind%2C%20editorial%20tech%20magazine%20photography%2C%20orange%20and%20crimson%20accent%20lighting%2C%20film%20grain%2C%20sharp%20center%20focus&width=800&height=560&seq=pol-guide-03&orientation=landscape",
  },
  {
    id: "vote-4",
    title: "粉丝集资打榜的风险提示：理性助力比冲量重要",
    lead: "盘点历届赛程里集资跑路、账目不清的典型案例，以及如何识别\"正规军\"与\"黑灰产\"。",
    tag: "理性追星",
    time: "5分钟阅读",
    img: "https://readdy.ai/api/search-image?query=Hands%20of%20young%20fans%20clasping%20heart%20shaped%20lightsticks%20over%20a%20crowd%2C%20soft%20warm%20spotlights%20and%20confetti%20falling%2C%20editorial%20documentary%20photography%2C%20orange%20and%20rose%20tones%2C%20subtle%20film%20grain%2C%20emotional%20central%20composition&width=800&height=560&seq=pol-guide-04&orientation=landscape",
  },
];

export const stagePairs = [
  {
    id: "stage-1",
    theme: "《主理人》第12期",
    artist: "陈希《逆风》",
    desc: "同一首歌，饭拍现场与官方直拍的热度与弹幕差异，以及两个版本里镜头语言的细微分野。",
    comparison: [
      { kind: "现场饭拍", point: "情绪递进更完整，副歌部分气息摩擦清晰可辨，饭圈称\"封神名场面\"。" },
      { kind: "官方直拍", point: "收音更干净、运镜更稳，适合循环，但过度锐化让高音略失质感。" },
      { kind: "榜单反馈", point: "直拍弹幕里\"听哭\"出现频率是饭拍的2.3倍，官方版更利于出圈传播。" },
    ],
    img: "https://readdy.ai/api/search-image?query=Young%20male%20singer%20silhouette%20reaching%20toward%20bright%20warm%20spotlights%20on%20a%20dark%20competition%20stage%2C%20dynamic%20high%20note%20pose%2C%20editorial%20concert%20photography%2C%20orange%20and%20crimson%20rim%20lighting%2C%20subtle%20film%20grain%2C%20high%20contrast%2C%20central%20dramatic%20composition&width=1200&height=750&seq=stage-pair-01&orientation=landscape",
  },
  {
    id: "stage-2",
    theme: "《新声实验班》第9期",
    artist: "苏念 vs 阿澈《双生》",
    desc: "一档对战合作舞台，把同一份直拍拆成两帧逐秒解析，看编排细节如何决定舞台质感。",
    comparison: [
      { kind: "编舞走位", point: "苏念的定点更利落，阿澈的走位更具叙事感，二者失误率伯仲之间。" },
      { kind: "镜头表现", point: "导播多给苏念近景，阿澈中远景偏多，直接影响二创素材的剪辑友好度。" },
      { kind: "综合口碑", point: "专业乐评更偏爱阿澈的声音处理，大众榜单则对苏念的视觉记忆点更买账。" },
    ],
    img: "https://readdy.ai/api/search-image?query=Two%20young%20dancers%20in%20symmetrical%20dynamic%20pose%20under%20a%20single%20warm%20spotlight%20on%20a%20dark%20stage%2C%20dust%20particles%20in%20the%20light%20beam%2C%20editorial%20performance%20photography%2C%20amber%20and%20rose%20tones%2C%20subtle%20film%20grain%2C%20high%20contrast%2C%20centered%20duo%20composition&width=1200&height=750&seq=stage-pair-02&orientation=landscape",
  },
];

export const gossipPosts = [
  {
    id: "gossip-1",
    title: "考古进行时：某练习生五年前的小号发言合集",
    lead: "网友翻出训练生早年在社交平台的发言与转发，时间线、语境与回应态度一并梳理，只呈现证据不下结论。",
    tag: "旧料考古",
    time: "2小时前",
    hot: "阅读 12.4w",
    img: "https://readdy.ai/api/search-image?query=Open%20vintage%20notebook%20and%20magnifying%20glass%20over%20old%20printed%20screenshots%20and%20photos%20on%20a%20warm%20wooden%20desk%2C%20editorial%20investigative%20magazine%20photography%2C%20orange%20desk%20lamp%20light%2C%20subtle%20film%20grain%2C%20close%20central%20composition&width=800&height=540&seq=gos-post-01&orientation=landscape",
  },
  {
    id: "gossip-2",
    title: "导师\"黑历史\"被挖出，综艺人设还剩多少可信度",
    lead: "从几段早年访谈与旧帖出发，讨论\"毒舌导师\"究竟是性格使然还是节目剧本，双方论据都摆给你看。",
    tag: "导师争议",
    time: "5小时前",
    hot: "阅读 9.8w",
    img: "https://readdy.ai/api/search-image?query=Dim%20warm%20studio%20with%20a%20host%20chair%20and%20microphones%20lit%20by%20a%20single%20amber%20spot%2C%20empty%20talking%20stage%2C%20mysterious%20editorial%20photography%2C%20orange%20and%20dark%20shadow%20tones%2C%20subtle%20film%20grain%2C%20centered%20composition&width=800&height=540&seq=gos-post-02&orientation=landscape",
  },
  {
    id: "gossip-3",
    title: "镜头之外：后台花絮里那些被忽略的\"细节瓜\"",
    lead: "放大花絮截图逐帧比对，考据走位、站位与交谈口型，拼出一张镜头外的关系网。",
    tag: "镜头考古",
    time: "8小时前",
    hot: "阅读 6.2w",
    img: "https://readdy.ai/api/search-image?query=Candid%20backstage%20scene%20of%20young%20performers%20chatting%20near%20a%20mirror%20with%20warm%20bulbs%2C%20costume%20racks%20and%20soft%20shadows%2C%20editorial%20backstage%20documentary%20photography%2C%20amber%20and%20rose%20tones%2C%20subtle%20film%20grain%2C%20natural%20candid%20composition&width=800&height=540&seq=gos-post-03&orientation=landscape",
  },
  {
    id: "gossip-4",
    title: "点赞量一夜翻倍？数据异常背后的三种可能性",
    lead: "从第三方检测工具的口径出发，拆解\"机器刷量、真实路人涌入、平台口径调整\"三种解释的合理性。",
    tag: "数据风波",
    time: "昨日",
    hot: "阅读 5.1w",
    img: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20dark%20computer%20screen%20with%20glowing%20analytics%20bars%20and%20numbers%20going%20up%2C%20warm%20orange%20reflection%20on%20the%20screen%2C%20editorial%20data%20storytelling%20photography%2C%20film%20grain%2C%20high%20contrast%2C%20focused%20center&width=800&height=540&seq=gos-post-04&orientation=landscape",
  },
  {
    id: "gossip-5",
    title: "旧照翻出同框：两位\"对家\"选手其实是多年好友",
    lead: "一组早年训练照让原本针锋相对的两个人设，在粉丝口中悄悄反转，考古帖留言区已经吵翻。",
    tag: "关系反转",
    time: "昨日",
    hot: "阅读 4.6w",
    img: "https://readdy.ai/api/search-image?query=Two%20worn%20polaroid%20photos%20of%20two%20smiling%20young%20friends%20laid%20on%20warm%20paper%20with%20tape%20and%20small%20markers%2C%20editorial%20nostalgic%20photography%2C%20amber%20lighting%2C%20subtle%20film%20grain%2C%20close%20central%20composition&width=800&height=540&seq=gos-post-05&orientation=landscape",
  },
  {
    id: "gossip-6",
    title: "赛制科普：争议不断的\"保送名额\"到底怎么来的",
    lead: "把历届复活、加权与保送条款做成对照表，帮你在吃瓜时看清规则本身是否存在模糊地带。",
    tag: "规则科普",
    time: "2天前",
    hot: "阅读 3.9w",
    img: "https://readdy.ai/api/search-image?query=Printed%20competition%20rulebook%20with%20highlighted%20paragraphs%20and%20a%20coffee%20cup%20on%20a%20warm%20desk%2C%20editorial%20documentation%20photography%2C%20soft%20amber%20light%2C%20subtle%20film%20grain%2C%20flat%20lay%20central%20composition&width=800&height=540&seq=gos-post-06&orientation=landscape",
  },
];

export const mentorMoments = [
  {
    id: "mentor-1",
    mentor: "林川",
    title: "犀利点评冲上热搜，节目方删减引发二度争议",
    quote: "点评原话在饭拍里流传开后，节目正片却出现删改，\"剪辑替导师圆场\"的讨论持续发酵。",
    stance: "网友争论",
    score: "争议值 92",
    img: "https://readdy.ai/api/search-image?query=Serious%20middle%20aged%20male%20judge%20sitting%20at%20a%20long%20judging%20table%20with%20microphone%2C%20holding%20pen%2C%20dark%20studio%20with%20warm%20key%20light%2C%20editorial%20tv%20panel%20photography%2C%20amber%20and%20crimson%20tones%2C%20subtle%20film%20grain%2C%20centered%20portrait%20composition&width=800&height=560&seq=men-moment-01&orientation=landscape",
  },
  {
    id: "mentor-2",
    mentor: "周雯",
    title: "一票之差引发导师互相质疑，VCR里埋了伏笔",
    lead: "两位导师对同一位选手给出相反结论，节目用回放镜头暗示背后另有隐情。",
    quote: "\"我不认为唱功能代表舞台的全部。\"\"可这里是选秀，不是音乐会。\"",
    stance: "针锋相对",
    score: "争议值 87",
    img: "https://readdy.ai/api/search-image?query=Female%20judge%20in%20elegant%20suit%20talking%20firmly%20into%20microphone%20at%20a%20judging%20desk%2C%20bright%20warm%20studio%20lights%2C%20editorial%20reality%20show%20photography%2C%20amber%20and%20rose%20tones%2C%20subtle%20film%20grain%2C%20centered%20composition&width=800&height=560&seq=men-moment-02&orientation=landscape",
  },
  {
    id: "mentor-3",
    mentor: "DJ 老K",
    title: "网感导师为何总被指责\"不够专业\"",
    lead: "一边是流量担当，一边被质疑只会抖包袱，我们统计了弹幕里对其点评的褒贬比例。",
    quote: "专业与娱乐的边界在哪里，成了评论区吵不出的题。",
    stance: "人设争议",
    score: "争议值 74",
    img: "https://readdy.ai/api/search-image?query=Young%20trendy%20male%20mentor%20laughing%20casually%20with%20headphones%20around%20neck%20at%20a%20light%20lit%20panel%20desk%2C%20colorful%20neon%20ambient%20lights%2C%20editorial%20entertainment%20photography%2C%20warm%20orange%20and%20magenta%20accents%2C%20subtle%20film%20grain%2C%20centered%20portrait%20composition&width=800&height=560&seq=men-moment-03&orientation=landscape",
  },
];

export const eliminateEvents = [
  {
    round: "35进30",
    title: "淘汰名单疑提前外泄",
    date: "本周三",
    desc: "深夜流传的一份\"保送名单\"让多个后援会紧急动员，节目组随后发声明称系恶意造谣，但粉丝并不买账。",
    tag: "名单泄露",
  },
  {
    round: "50进35",
    title: "冷门选手逆袭，导师组临时加赛",
    date: "上周日",
    desc: "排名垫底选手靠现场发挥逆势翻盘，导演组临时调整赛程，被质疑\"剧本感太强\"。",
    tag: "赛制争议",
  },
  {
    round: "第一轮",
    title: "初舞台镜头被剪到仅剩7秒",
    date: "月初",
    desc: "多位选手反映初舞台镜头严重缩水，剪辑分配不均的旧账被重新翻出，播出组作出回应。",
    tag: "剪辑争议",
  },
  {
    round: "背景",
    title: "历届\"复活\"名场面盘点",
    date: "专题",
    desc: "把历季复活赛的票数与口碑做横向对比，看复活条款在真实赛程里到底怎么生效。",
    tag: "复盘专题",
  },
];

export const faqs = [
  {
    q: "每日大赛网的内容从哪里来？",
    a: "我们是一站式的选秀资讯整理与评析站点。团队会在直播结束后第一时间核对公开饭拍、官方直拍、榜单与节目正片，再结合饭圈讨论与公开数据做二次梳理，标注信息出处并区分事实与观点。",
  },
  {
    q: "投票打榜攻略每期都会更新吗？",
    a: "会。每次赛程开启新打榜周期、调整助力规则或上线双平台联动时，我们都会在「投票打榜」板块更新攻略，并把历期规则改动整理成对照表方便你查询。",
  },
  {
    q: "舞台直拍对比是怎么做的？",
    a: "我们会针对同一首歌的现场饭拍、官方直拍与录音室版本，从收音、运镜、情绪递进和榜单反馈四个维度逐帧比对，给出直观的对比拆解，方便你快速判断哪个版本更适合观看或二创。",
  },
  {
    q: "选手与导师的热议内容真实吗？",
    a: "对于选手与导师的热议、旧料与争议，我们坚持\"呈现证据、不做定论\"的原则：所有考据都会标注时间与出处，对未经官方证实的内容明确标注\"存疑\"，不做主观定罪式的解读。",
  },
  {
    q: "淘汰内幕板块的信息可靠吗？",
    a: "淘汰内幕板块会区分\"已官宣事实\"与\"网友猜测\"两类，只转载有明确来源的爆料并在标题注明性质，同时尽量补充节目组的回应，帮助你判断可信度。",
  },
  {
    q: "我如何投稿或反馈一条线索？",
    a: "如果你有直拍对比、规则漏洞或争议考古的线索，欢迎通过页脚的联系表单发送给我们。核实并确认信源后，我们会标注你的线索来源后整理发布。",
  },
];

export const reviews = [
  {
    name: "一只打榜鸽",
    role: "站子管理员 · 追《星光主理人》",
    text: "每轮赛制更新都能在这里找到整理好的规则对照，省下我翻公告的时间，直拍对比那篇也很有用。",
    tag: "打榜攻略",
  },
  {
    name: "考古不睡",
    role: "镜头细节控",
    text: "难得有地方把旧料和时间线摆得这么清楚，证据和猜测分开标注，吃瓜也能吃得有分寸。",
    tag: "镜头考古",
  },
  {
    name: "路过的制片",
    role: "综艺从业者",
    text: "对剪辑分配、保送条款和复活机制的复盘很专业，视角客观，是目前少见的\"懂行\"盘点。",
    tag: "规则复盘",
  },
];

export const brandPoints = [
  { title: "时效第一", desc: "直播结束即盘点，打榜、直拍、热议同步追踪" },
  { title: "证据先行", desc: "所有考据标注出处，事实与观点分得清清楚楚" },
  { title: "理性吃瓜", desc: "不做定罪式解读，存疑信息一律明说" },
  { title: "反哺粉丝", desc: "规则对照表与避坑清单帮你省心追星" },
];

export const relatedLinks = [
  { title: "投票打榜规则对照表", desc: "历期助力规则改动一站式查询", icon: "ri-bar-chart-line" },
  { title: "直拍版本音质指南", desc: "现场版与官方版的挑选方法论", icon: "ri-music-2-line" },
  { title: "导师点评名场面合集", desc: "从饭拍流传到正片删改的完整记录", icon: "ri-chat-quote-line" },
  { title: "淘汰复活条款解读", desc: "保送与加赛条款的白话翻译", icon: "ri-file-list-3-line" },
];